import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

const tooltipRoot = document.getElementById('tooltip-root');

const TooltipContext = React.createContext({
  showTooltip: () => {},
  hideTooltip: () => {},
});

export const useTooltipPortal=()=>useContext(TooltipContext);

const TooltipPortal = () => {
  const { tooltipState } = useContext(TooltipContext);
  const { message, position, show } = tooltipState;

  if (!show || !message) return null;

  return createPortal(
    <div
      style={{
        position: 'absolute',
        top: `${position.top}px`,
        left: `${position.left}px`,
        backgroundColor: '#333',
        color: '#fff',
        padding: '4px 8px',
        borderRadius: '4px',
        fontSize: '12px',
        zIndex: 10000000,
        whiteSpace: 'nowrap',
      }}
    >
      {message}
    </div>,
    tooltipRoot
  );
};

export const TooltipWrapper = ({ children }) => {
  const [tooltipState, setTooltipState] = useState({
    show: false,
    message: '',
    position: { top: 0, left: 0 },
  });

  const showTooltip = useCallback((targetRef, message) => {
    if (targetRef.current && message) {
      const rect = targetRef.current.getBoundingClientRect();
      setTooltipState({
        show: true,
        message,
        position: {
          top: rect.bottom + window.scrollY + 5,
          left: rect.left + window.scrollX,
        },
      });
    }
  }, []);

  const hideTooltip = useCallback(() => {
    setTooltipState({
      show: false,
      message: '',
      position: { top: 0, left: 0 },
    });
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipState.show && !event.target.closest('#tooltip-root')) {
        hideTooltip();
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [tooltipState.show, hideTooltip]);

  return (
    <TooltipContext.Provider value={{ showTooltip, hideTooltip, tooltipState }}>
      {children}
      <TooltipPortal />
    </TooltipContext.Provider>
  );
};
